// extracted by mini-css-extract-plugin
export var applied = "discount-code-input-module--applied--52aeb";
export var button = "discount-code-input-module--button--81cd5";
export var discountCodeInput = "discount-code-input-module--discount-code-input--653a4";
export var discountCodeInputWrapper = "discount-code-input-module--discount-code-input-wrapper--4a33d";
export var input = "discount-code-input-module--input--66613";
export var inputWrapper = "discount-code-input-module--input-wrapper--42dd8";
export var message = "discount-code-input-module--message--d8114";
export var outlined = "discount-code-input-module--outlined--3f959";